import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import DashboardCard from "../../pages/home/common/DashboardCard";
import {
  fetchAttendanceChartData,
  fetchTotalCheckinsData,
} from "../../redux/reducers/apiSlice";
import { convertStraight } from "../common-data/Converts";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import AAAGADetails from "./aaaga-details/AAAGADetails";

const AAAGACards = ({ userInfoData, prevFilters }) => {
  const dispatch = useDispatch();
  const { attendanceChart, totalCheckins, loading } = useSelector(
    (state) => state.api
  );

  const iniModVal = {
    cardModal: false,
    clickedCard: "",
    cardTag: "",
  };
  const [modValues, setModValues] = useState(iniModVal);
  const [cardStats, setCardStats] = useState({});
  const [totalCheckinsData, setTotolCheckinsData] = useState(0);

  const onCloseModal = () => {
    setModValues(iniModVal);
  };

  const onClickCard = (cardLabel, cardTag) => {
    setModValues((prevs) => ({
      ...prevs,
      cardModal: true,
      clickedCard: cardLabel,
      cardTag: cardTag,
    }));
  };

  function getCardStats() {
    const { date_from, date_to, ...rest } = prevFilters;
    const pieChartGetApiFilters = {
      ...rest,
      chart_type: "pie",
      date_from: convertStraight(date_from),
      date_to: convertStraight(date_to),
    };

    dispatch(
      fetchAttendanceChartData({
        filters: pieChartGetApiFilters,
        token: userInfoData?.token,
      })
    );
  }

  function getAttendanceStats() {
    const { date_from, date_to, ...rest } = prevFilters;
    const updatedFilters = {
      ...rest,
      date_from: convertStraight(date_from),
      date_to: convertStraight(date_to),
    };

    dispatch(
      fetchTotalCheckinsData({
        filters: updatedFilters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getCardStats();
    getAttendanceStats();
  }, [prevFilters]);

  useEffect(() => {
    if (attendanceChart?.status && attendanceChart?.data) {
      setCardStats(attendanceChart.data);
    } else {
      setCardStats({});
    }
  }, [attendanceChart]);

  useEffect(() => {
    if (totalCheckins?.status && totalCheckins?.data?.all) {
      setTotolCheckinsData(totalCheckins.data.all?.total);
    } else {
      setTotolCheckinsData(0);
    }
  }, [totalCheckins]);

  return (
    <>
      <Modal
        isOpen={modValues.cardModal}
        onRequestClose={onCloseModal}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        <div className={`createNewCTOModalContainer live-monitoring-modal`}>
          <ModalHeadAndClose
            title={`${modValues.clickedCard?.replace(/_/g, " ")}`}
            onClose={onCloseModal}
          />

          <AAAGADetails
            userInfoData={userInfoData}
            clickedCard={modValues}
            prevFilters={prevFilters}
          />
        </div>
      </Modal>

      {loading ? (
        <ReactVortoxSpinner />
      ) : (
        <div className="cards-container cards-grid-container grid-4 mt-2rem">
          <DashboardCard
            tagName={"all"}
            cardLabel={"All Checked-in Users"}
            value={`${totalCheckinsData || 0}`}
            onClickCard={onClickCard}
          />
          <DashboardCard
            tagName={"staff"}
            cardLabel={"Checked-in Sales Executives"}
            value={`${cardStats?.staff?.total_current || 0}/${
              cardStats?.staff?.total || 0
            }`}
            onClickCard={onClickCard}
          />
          <DashboardCard
            tagName={"trainer"}
            cardLabel={"Checked-in Trainers"}
            value={`${cardStats?.trainers?.total_current || 0}/${
              cardStats?.trainers?.total || 0
            }`}
            x
            onClickCard={onClickCard}
          />
          <DashboardCard
            tagName={"member"}
            cardLabel={"Checked-in Members"}
            value={`${cardStats?.active_members?.total_current || 0}/${
              cardStats?.active_members?.total || 0
            }`}
            onClickCard={onClickCard}
          />
          <DashboardCard
            tagName={"guest"}
            cardLabel={"Checked-in Guest Users"}
            value={`${cardStats?.guest?.total_current || 0}/${
              cardStats?.guest?.total || 0
            }`}
            onClickCard={onClickCard}
          />
        </div>
      )}
    </>
  );
};

export default AAAGACards;
